import React, { useState } from 'react';
import Modal from '../../../../common/components/Modal';
import { ReactComponent as PenIcon } from '../../assets/pen.svg';
import { ReactComponent as TrashIcon } from '../../assets/trash.svg';
import styles from './BookmarkCard.module.css';
import { format, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { env } from '../../../../env';

type BookmarkCardProps = {
  id: number;
  linkUrl: string;
  link: string;
  description?: string;
  notes?: string;
  added: string;
  handleBookmarkDelete: (id: number) => void;
  handleNotesChange: (bookmarkId: number, notes: string) => void;
};

const BookmarkCard = (props: BookmarkCardProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleModalOpen = () => {
    setIsOpen(true);
  };

  const handleModalClose = () => {
    setIsOpen(false);
  };

  const handleDelete = () => {
    props.handleBookmarkDelete(props.id);
    handleModalClose();
  };

  const handleNotesChange = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    props.handleNotesChange(props.id, e.target.value);
  };

  const formatDate = (value: string) => {
    return value ? format(parseISO(value), 'MMMM d, yyyy', { locale: enUS }) : '';
  };

  const linkUrl = (value: string) => {
    return value.startsWith('http') ? value : env.REACT_APP_SHAREPOINT_BASE_URL.concat(value);
  };
  return (
    <>
      <Modal open={isOpen}>
        <div className={styles.modalHeader}>Remove Bookmark</div>
        <div className={styles.modalBody}>
          Are you sure you want to remove this bookmark and all of its notes?
        </div>
        <div className={styles.modalButtons}>
          <button className={styles.blueButton} onClick={handleDelete}>
            Yes
          </button>
          <button className={styles.whiteButton} onClick={handleModalClose}>
            No
          </button>
        </div>
      </Modal>

      {props.id && (
        <div className={styles.bookmarkCard}>
          <div>
            <a href={linkUrl(props.linkUrl)} target='_blank'>
              {props.link}
            </a>
          </div>
          <p>{props.description}</p>

          <div className={styles.textArea}>
            <PenIcon className={styles.penIcon} />
            <textarea defaultValue={props.notes} onBlur={handleNotesChange} />
          </div>
          <div className={styles.footer}>
            <div className={styles.dateAdded}>ADDED: {formatDate(props.added)}</div>
            <div className={styles.wrapper}>
              <TrashIcon className={styles.trashIcon} onClick={handleModalOpen} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default BookmarkCard;
